import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import React__default, { useRef, useState, useCallback } from 'react';
import MuiBox from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import MuiTypography from '@mui/material/Typography';
import { Link } from '@mui/material';
import '../../../../hooks/useScrollCapture/supportsPassiveEvents.js';
import useHighlight from '../../../../hooks/useHighlight.js';
import Hint from '../../../Hint/Hint.js';

const Root = styled(MuiBox, {
    shouldForwardProp: prop => !['relative'].includes(prop),
}) `
  ${({ relative }) => `
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    overflow: hidden;
    position: relative;
    width: 100%;
    height: 100%;
  
    > span,
    p {
      position: ${relative ? 'relative' : 'absolute'};
      width: 100%;
    }
  `}
`;
const TextCellLink = styled(Link) `
  user-select: none;
  -webkit-user-drag: none;
  text-decoration: none;
  color: inherit;
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.palette.primary.main};
  }
`;
const TextCellRenderer = React__default.memo(({ value, state, typography, linkTo, onClick, relative = false, className, column, row }) => {
    const markText = useHighlight(state === null || state === void 0 ? void 0 : state.globalFilter);
    const elementRef = useRef(null);
    const [openTooltip, setOpenTooltip] = useState(false);
    const onMouseOver = useCallback(() => {
        if (elementRef.current) {
            const { offsetWidth, scrollWidth } = elementRef.current;
            setOpenTooltip(offsetWidth < scrollWidth);
        }
    }, []);
    const onMouseOut = useCallback(() => {
        setOpenTooltip(false);
    }, []);
    const onLinkClick = useCallback((e) => {
        e.stopPropagation();
        onClick && onClick(row, e);
    }, [onClick, row]);
    const onLinkNavigate = useCallback((e) => {
        e.stopPropagation();
        window.open(linkTo);
    }, [linkTo]);
    if (!value) {
        return null;
    }
    const text = !column.disableGlobalFilter ? markText(value) : value;
    return (jsx(Root, Object.assign({ relative: relative, className: className }, { children: jsx(Hint, Object.assign({ title: openTooltip ? value : '', placement: "top" }, { children: jsxs(MuiTypography, Object.assign({}, typography, { noWrap: true, ref: elementRef, onMouseOver: onMouseOver, onMouseOut: onMouseOut }, { children: [linkTo && !onClick && jsx(TextCellLink, Object.assign({ onClick: onLinkNavigate }, { children: text })), !linkTo && onClick && jsx(TextCellLink, Object.assign({ onClick: onLinkClick }, { children: text })), !linkTo && !onClick && jsx(Fragment, { children: text })] })) })) })));
});
TextCellRenderer.displayName = 'TextCellRenderer';

export { TextCellRenderer as default };
//# sourceMappingURL=TextCellRenderer.js.map
